import {
  BrandPowerStations,
  PowerStation,
  PowerStationInternal,
} from "../types/products";
import { buildProductRecord } from "../utils/products";

const brand = "DJI Power";
const rawData: PowerStationInternal[] = [
  {
    name: "2000",
    amazon: {
      href: "https://www.amazon.com/dp/B0FBRD1B8C/",
      affiliate: "https://amzn.to/4sFwhNb",
    },
    img: "/images/products/dji/2000/front.webp",

    price: 749,
    capacity: 2048,
    acOutput: 3000,
    dcOutput: 0,
    solar: 0,
    expandable: true,

    displayPowerSystemsPage: true,
  },
];

const powerStations: BrandPowerStations = {
  name: brand,
  powerStations: buildProductRecord<PowerStationInternal, PowerStation>(
    rawData,
    brand
  ),
};

export default powerStations;
